class FragmentDTO {
  constructor() {
    this.lines = [];
    this.isHidden = false;
    this.isSignature = false;
    this.isQuoted = false;
  }
}

module.exports = FragmentDTO;